import { memo, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Text, Icon, useTheme } from '@Sage/hoi-poi-ui';
import { PATH_IMAGE } from 'constants/Environment';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const GEOLOCATION_ON_IMAGE = `${PATH_IMAGE}illustration_geolocation_on.png`;
const GEOLOCATION_OFF_IMAGE = `${PATH_IMAGE}illustration_geolocation_off.png`;
const GOOGLE_MAPS_URL = 'https://www.google.com/maps/search/?api=1&query=';

const MapDisplay = memo(({ isGeoLocated, latitude, longitude }) => {
    const theme = useTheme();

    const imageUrl = useMemo(() => {
        return isGeoLocated ? GEOLOCATION_ON_IMAGE : GEOLOCATION_OFF_IMAGE;
    }, [isGeoLocated]);

    const onShowMap = useCallback(() => {
        window.open(`${GOOGLE_MAPS_URL}${latitude},${longitude}`, '_blank');
    }, [latitude, longitude]);

    return (
        <div
            className={classNames('entity-location-widget__map', {
                'entity-location-widget__map--geolocated': isGeoLocated,
            })}
        >
            <img src={imageUrl} alt="Location status" />
            {isGeoLocated && (
                <div className="entity-btn-show-map" onClick={onShowMap}>
                    <Text type="caption" color={theme.colors.primary.white}>
                        {getLiteral('action_show_map')}
                    </Text>
                    <Icon name="launch" color={theme.colors.primary.white} />
                </div>
            )}
        </div>
    );
});

MapDisplay.propTypes = {
    isGeoLocated: PropTypes.bool.isRequired,
    latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default MapDisplay;
